import { useEffect, useRef } from "react";
import { useDirtySyncedState } from "../lib/useDirtySyncedState.ts";

/** Left-rail private operator notes (never shown to moderator or room).
 *  Debounced 500ms after the last keystroke before calling onSetNotes. */
export function NotesPanel({
  sessionId,
  notes,
  onSetNotes,
}: {
  sessionId: string;
  notes: string;
  onSetNotes: (notes: string) => void;
}) {
  const { draft: val, setDraft: setVal } = useDirtySyncedState({
    value: notes,
    resetKey: sessionId,
  });
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  function onChange(v: string) {
    setVal(v);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => onSetNotes(v), 500);
  }

  return (
    <section className="panel notes-panel">
      <h2>Notes</h2>
      <textarea
        data-testid="notes-input"
        value={val}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Running notes for the admin (logged, never shown to the moderator)…"
        rows={4}
      />
    </section>
  );
}
